// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-toolbar .ol-control {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    z-index: 10;
    margin: 0;
}

.control-pane--bottom .map-toolbar .ol-control {
    margin-left: 6px;
}

.control-pane--bottom .map-toolbar .ol-control:first-child {
    margin-left: 0;
}

.control-pane--top .map-toolbar .ol-control {
    margin-top: 8px;
}

.control-pane--top .map-toolbar .ol-control:first-child {
    margin-top: 0;
}

.map-toolbar .ol-control .toggle-button {
    fill: var(--primary);
    transition: none;
    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
    border: 0;
    background: #fff;
    padding: 0;
    width: 30px;
    height: 30px;
    color: var(--primary);
    line-height: 30px;
    text-shadow: none;
}

.map-toolbar .ol-control .toggle-button:hover {
    background: #f9fafb;
}

/* Move somewhere, for the whole map */

.ol-control .toggle-button.checked,
.map-toolbar .ol-control.toggle-button.checked {
    fill: #fff;
    background: var(--primary);
    color: #fff;
}

.map-toolbar .ol-control .toggle-button .toggle-button-container {
    display: inline-block;
}

.map-toolbar .ol-control .toggle-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/map-toolbar/MapToolbar.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,2CAA2C;IAC3C,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sCAAsC;;AAEtC;;IAEI,UAAU;IACV,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":[".map-toolbar .ol-control {\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n    z-index: 10;\n    margin: 0;\n}\n\n.control-pane--bottom .map-toolbar .ol-control {\n    margin-left: 6px;\n}\n\n.control-pane--bottom .map-toolbar .ol-control:first-child {\n    margin-left: 0;\n}\n\n.control-pane--top .map-toolbar .ol-control {\n    margin-top: 8px;\n}\n\n.control-pane--top .map-toolbar .ol-control:first-child {\n    margin-top: 0;\n}\n\n.map-toolbar .ol-control .toggle-button {\n    fill: var(--primary);\n    transition: none;\n    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n    border: 0;\n    background: #fff;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    color: var(--primary);\n    line-height: 30px;\n    text-shadow: none;\n}\n\n.map-toolbar .ol-control .toggle-button:hover {\n    background: #f9fafb;\n}\n\n/* Move somewhere, for the whole map */\n\n.ol-control .toggle-button.checked,\n.map-toolbar .ol-control.toggle-button.checked {\n    fill: #fff;\n    background: var(--primary);\n    color: #fff;\n}\n\n.map-toolbar .ol-control .toggle-button .toggle-button-container {\n    display: inline-block;\n}\n\n.map-toolbar .ol-control .toggle-button.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
